import React from 'react';
import { DatePicker as MuiDatePicker, DatePickerProps } from '@mui/x-date-pickers';
import { SxProps } from '@mui/system';

interface IProps extends DatePickerProps<any, any> {
  label?: string;
  error?: boolean;
  required?: boolean;
  fullWidth?: boolean;
  helperText?: string;
  timeZone?: string;
  InputComponent: React.ElementType;
  onBlur: () => void;
}

const DatePickerNext: React.FC<React.PropsWithChildren<IProps>> = (props) => {
  const {
    InputComponent,
    label,
    error,
    helperText,
    fullWidth,
    onBlur,
    open,
    onOpen,
    onChange,
    value,
    required,
    ...rest
  } = props;

  const popperSx: SxProps = {
    '& .MuiPickersCalendarHeader-root, .MuiSvgIcon-root': {
      color: '#4E6DF5',
    },
    '& .MuiPickersCalendarHeader-label': {
      fontSize: 16,
      fontWeight: 600,
    },
    '& .MuiPickersDay-root': {
      fontSize: 15,
      fontWeight: 600,
      color: '#383C44',
      borderRadius: '6px',
      ':first-of-type': {
        color: '#F65675',
      },
    },
    '& .Mui-selected': {
      color: '#fff !important',
      backgroundColor: '#4E6DF5',
    },
  };

  // JPA-8300: pass the picked/typed date through as-is. A previous workaround rewrote
  // the month and day to today's whenever the field was still empty and the new year
  // differed from the current one, which corrupted both typed dates and calendar day
  // clicks in another year. MUI already resolves an empty year selection itself
  // (YearPicker uses startOfYear(now) as the base when the value is null).
  const handleChange = (v: any) => onChange(v?.toDate() || null);

  return (
    <MuiDatePicker
      PopperProps={{
        sx: popperSx,
      }}
      {...rest}
      value={value}
      onChange={handleChange}
      open={open}
      renderInput={(props) => (
        <InputComponent
          {...props}
          open={open}
          onClick={onOpen}
          onBlur={onBlur}
          fullWidth={fullWidth}
          required={required}
          label={label}
          value={value}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};

export default DatePickerNext;
